/** ページごとのID */
export const PAGE_ID = {
  /** 問診画面 */
  INQUIRY: "RC-01",
  /** カテゴリー一覧画面 */
  RECIPE_CATEGORIES_LIST: "RC-02",
  /** カテゴリー詳細画面 */
  RECIPE_CATEGORIES_DETAIL: "RC-03",
  /** レシピ詳細画面 */
  RECIPE_DETAIL: "B-05",
  /** ホーム画面 */
  HOME_TOP: "B-21",
  /** サービス一覧 */
  HOME_SERVICE: "B-26",
  /** おすすめレシピ一覧 */
  HOME_RECOMMEND: "B-33",
  /** 人気レシピ一覧 */
  HOME_RANKING: "B-34",
  /** マイリストレシピ一覧 */
  HOME_MY_LIST: "B-35",
  /** レシピトップ画面 */
  RECIPE_SEARCH_TOP: "G-05",
  /** 検索詳細画面 */
  SEARCH_DETAIL: "G-06",
  /** 機器連携の検索対象選択画面 */
  SEARCH_APPLIANCE_DIALOG: "G-07",
  /** 検索結果 */
  SEARCH_RESULT: "G-09",
  /** レシピ人気レシピ一覧 */
  RECIPE_RANKING: "G-10",
  /** お気に入りの履歴 */
  FAVORITES_HISTORIES: "E-04",
  /** お気に入り閲覧履歴 */
  FAVORITES_DISPLAYED_LIST: "E-06",
  /** お気に入り送信履歴 */
  FAVORITES_SENDED_LIST: "E-07",
  /** お気に入りのマイリスト */
  FAVORITES_MYLIST: "E-08",
  /** お気に入り最近追加したもの */
  FAVORITES_MYLIST_RECENT_LIST: "E-09",
  /** お気に入りフォルダ */
  FAVORITES_MYLIST_FOLDER: "E-12",
  /** お気に入り追加レシピ選択 */
  FAVORITES_MYLIST_SELECT: "E-13",
  /** マイページTOP：お気に入り */
  MYPAGE_TOP_RECIPE: "E-18",
  /** マイページTOP：レポート */
  MYPAGE_TOP_REPORT: "E-21",
  /** マイページ：お気に入り食材 */
  MYPAGE_FAVORITE_FOODS: "E-19",
  /** マイページ： 食材使い切り（月間）*/
  MYPAGE_MONTHLY_FOOD_RANKING: "E-28",
  /** マイページ： 使い切りランキング説明 */
  MYPAGE_USEDRANKING_DESCRIPTION: "E-47",
  /** マイページ： 使い切りランキング（月間-あなた）*/
  MYPAGE_USED_RANKING_USER: "E-33",
  /** マイページ： 使い切りランキング（月間-全国）*/
  MYPAGE_USED_RANKING_NATIONWIDE: "E-34",
  /** マイページ： 捨てたランキング（月間-あなた）*/
  MYPAGE_DISPOSED_RANKING_USER: "E-35",
  /** マイページ： 捨てたランキング（月間-全国）*/
  MYPAGE_DISPOSED_RANKING_NATIONWIDE: "E-36",
  /** ダイアログ */
  DIALOG: "Y-01",
  /** 未定義 */
  OTHER: ""
};
